import makeIcon from './make_icon';
var roundFilled = "M21,12.0001831c0,0.2763672-0.2236328,0.5-0.5,0.5h-17c-0.2763672,0-0.5-0.2236328-0.5-0.5\n\ts0.2236328-0.5,0.5-0.5h17C20.7763672,11.5001831,21,11.7238159,21,12.0001831z";
var roundLined = "M21,12.0001831c0,0.2763672-0.2236328,0.5-0.5,0.5h-17c-0.2763672,0-0.5-0.2236328-0.5-0.5\n\ts0.2236328-0.5,0.5-0.5h17C20.7763672,11.5001831,21,11.7238159,21,12.0001831z";
var sharpFilled = "M21,11.5001831v1H3v-1H21z";
var sharpLined = "M21,11.5001831v1H3v-1H21z";
var IconMinus = makeIcon('IconMinus', 'Minus', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconMinus;